export default __webpack_public_path__ + "static/media/bg.f2dc1ca0.png";